import React, { FC, ReactNode, RefObject } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import isMobile from 'src/common/utils/isMobile';
import getClassName from 'src/common/utils/getClassName';
import FieldWrapper from '../FieldWrapper';
import FormError from '../../FormError';
import s from './TextArea.module.scss';

type TextAreaProps = {
  input: Record<string, any>;
  meta: Record<string, any>;
  placeholder?: string;
  classNameModifier?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  children?: ReactNode;
  label?: ReactNode;
  id?: string;
  autoResize?: boolean;
  fieldRef?: RefObject<HTMLDivElement>;
  textareaRef?: RefObject<HTMLTextAreaElement>;
  renderErrorMessage?: boolean;
  withIcon?: boolean;
  maxLength?: number;
};

const TextArea: FC<TextAreaProps> = ({
  id,
  input,
  placeholder,
  classNameModifier,
  disabled,
  autoFocus,
  autoResize,
  meta: { error },
  textareaRef,
  renderErrorMessage = true,
  withIcon = false,
  maxLength,
}) => {
  const Component = autoResize ? TextareaAutosize : 'textarea';
  // This is because React gets grumpy if you put useCacheForDomMeasurements
  // on a normal textarea.
  const componentProps = autoResize ? { cacheMeasurements: true } : {};
  const modifiers = [
    classNameModifier,
    renderErrorMessage && error ? 'error' : '',
  ].join(' ');

  return (
    <FieldWrapper
      id={id || input.name}
      // TODO: figure out if this is a sane way of composing styles
      rootClassName={getClassName(s, 'root', modifiers)}
    >
      <Component
        id={id || input.name}
        placeholder={placeholder}
        // TODO: this should probably come from form state,
        // not be a separate prop. What's the use case again?
        disabled={disabled}
        autoFocus={!isMobile() && autoFocus}
        className={getClassName(s, 'field', modifiers)}
        // TODO: figure out what this does, or if it does anything
        ref={textareaRef}
        maxLength={maxLength}
        {...componentProps}
        {...input}
      />
      {renderErrorMessage && error && (
        <FormError error={error} withIcon={withIcon} />
      )}
    </FieldWrapper>
  );
};

export default TextArea;
